import { CmsValue } from 'core/type/BootstrapConfig.types';
import { CategoryCms, CategoryId } from 'core/type/Category.types';
import {
    getActivitiesHomeUrl,
    getSearchPageFromCityIdAndCategoryIdUrlWithoutResetScrollPosition,
    getSearchPageFromCityIdUrlWithoutResetScrollPosition,
} from 'core/utils/activityUrlGenerator';
import { getBootstrapConfig, getWindowLocation } from 'core/window/windowService';

export const generateBreadCrumbsForDetailsPage = (cms: CmsValue, activityID: number, categoryId: string | undefined, title: string) => {
    const categoryCMS = categoryId ? CategoryCms[categoryId as keyof typeof CategoryCms] : undefined;
    const geo = getBootstrapConfig().geo;
    const cityID = geo?.cityId as number;
    const cityName = geo?.cityNameTranslated as string;

    const enumKeys = Object.keys(CategoryId);
    const selectedIndexKey = categoryId ? enumKeys.indexOf(categoryId) : undefined;

    const isCityDataAvailable = cityID && cityName;
    const isCategoryDataAvailable = categoryId && categoryCMS && selectedIndexKey;
    const breadcrumbs = [
        {
            content: cms[337221],
            link: getActivitiesHomeUrl(),
        },
    ];

    if (isCityDataAvailable) {
        breadcrumbs.push({
            content: cityName,
            link: getSearchPageFromCityIdUrlWithoutResetScrollPosition(cityID),
        });
    }

    if (isCityDataAvailable && isCategoryDataAvailable) {
        breadcrumbs.push({
            content: cms[categoryCMS],
            link: getSearchPageFromCityIdAndCategoryIdUrlWithoutResetScrollPosition(cityID, selectedIndexKey),
        });
    }

    breadcrumbs.push({
        content: title,
        link: getWindowLocation().href,
    });

    return breadcrumbs;
};
